
<div class="container-fluid">
<img style="width:100%; height: 80vh; object-fit:contain" src="/assets/{{big_logo}}">
</div>
